import { render, staticRenderFns } from "./WebStoreMember.vue?vue&type=template&id=08b0934e&"
import script from "./WebStoreMember.vue?vue&type=script&lang=js&"
export * from "./WebStoreMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports